// extracted by LIB_CSS_EXTRACT_LOADER
import "./counting-number_module.css"
export default {"countingNumber":"countingNumber-eSvKKR"};